var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0286 14.159C36.8393 15.0377 36.8393 16.4623 36.0286 17.341L24.3487 30L36.0286 42.659C36.8393 43.5377 36.8393 44.9623 36.0286 45.841C35.2178 46.7197 33.9034 46.7197 33.0927 45.841L19.9449 31.591C19.1342 30.7123 19.1342 29.2877 19.9449 28.409L33.0927 14.159C33.9034 13.2803 35.2178 13.2803 36.0286 14.159Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.46b60ca72384e9dfb0425afdecaa2cb0.svg";
export { ForwardRef as ReactComponent };